import * as React from "react";

const FloorplanSVG = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width="100%"
        viewBox="-60 -60 1340 1120"

        style={{
            background: "#e8f4fc",
            minHeight: "700px",
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            imageRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
        }}
        {...props}
    >
        <defs>
            <style type="text/css">
                {`
          .str1 {stroke:#F58262;stroke-width:0.5;stroke-miterlimit:4}
          .str0 {stroke:white;stroke-width:0.2;stroke-miterlimit:10}
          .fil5 {fill:none}
          .fil1 {fill:#D2E4EC}
          .fil6 {fill:white}
          .fil0 {fill:#416B82;fill-rule:nonzero}
          .fil7 {fill:#A5C7D7;fill-rule:nonzero}
          .fil2 {fill:#D2E4EC;fill-rule:nonzero}
          .fil3 {fill:#F58262;fill-rule:nonzero}
          .fil4 {fill:white;fill-rule:nonzero}
        `}
            </style>
        </defs>

        {/* Example: scale down your paths/polygons */}
        <g transform="scale(0.0117, 0.0114)">
            {/* Paste your large SVG paths/polygons here */}
            {/* For example: */}
            <polygon className="fil1" points="102869.35,85500.04 102936.48,85500.04 102936.48,86507.9 102869.35,86507.9" />
            <rect
                x={9000}
                y={1000}
                width={1020}
                height={900}
                fill="none"
                stroke="#7eb8d8"
                strokeWidth="2"
                strokeDasharray="8 4"
            />
            {/* All other elements... */}
            <g id="_2084393419648">
                <rect class="fil0" x="81476.37" y="11643.03" width="576.49" height="59350.28" />
                <path class="fil1" d="M82053 14544.22c-6.54,0.49 -12.95,1.05 -19.45,1.56l0 -3.12c6.5,0.51 12.91,1.07 19.45,1.56zm0 52135.31c-6.54,0.49 -12.95,1.05 -19.45,1.56l0 -3.12c6.5,0.51 12.91,1.07 19.45,1.56zm-339.95 37.08c-1047.47,154.15 -1572.43,636.5 -1691.35,1373.89l1691.35 0 320.5 0 19.45 0 0 -1410.97 0 -1410.97 -19.45 0 -320.5 0 -1691.35 0c118.92,737.39 643.88,1219.73 1691.35,1373.89l0 74.16zm-20202.43 -63836.89l2736.77 0 17313.14 0 0 8254.12 -385.14 0 0 977.01 385.14 0 454.36 0 362.32 0 0 -13.46 21264.05 0 0 11279.75 -2397.78 0c168.6,1302.44 912.81,2154.38 2397.78,2426.65l0 130.99c-1484.97,272.27 -2229.18,1124.22 -2397.78,2426.65l2397.78 0 0 34176.54 -2397.78 0c168.6,1302.44 912.81,2154.38 2397.78,2426.65l0 130.99c-1484.97,272.27 -2229.18,1124.22 -2397.78,2426.65l2397.78 0 0 27.85 -2643.34 2942.89 0 -292.08 -1201.82 0 0 522.65 -17476.97 0 0 -522.65 -1201.82 0 0 522.65 -19648.54 0 0 -1529.39 -1201.82 0 0 1529.39 -19552.4 0 0 -1529.39 -1201.82 0 0 1529.39 -18220.7 0 0 -1529.39 -1201.82 0 0 1529.39 -18440 0 0 -1529.39 -1195.85 0 0 -66314.47 20633.36 0 2736.77 0 37686.12 0zm20308.17 -406.46l0 -47.9 -17638 0c-292.96,-1503.24 -1231.11,-2255.73 -2670.17,-2425.36l0 2425.36 -37752.73 0c-292.96,-1503.24 -1231.11,-2255.73 -2670.17,-2425.36l0 2425.36 -21016.11 0 0 47.9 -71.62 0 0 66720.93 0 1983.75 71.62 0 382.75 0 1195.85 0 6656.7 0 0 2790.87c1412.66,-182.87 2295.34,-1042.93 2483.23,-2790.87l17.84 0c187.89,1747.94 1070.57,2608 2483.23,2790.87l0 -2790.87 6799.01 0 1201.82 0 6582.51 0 0 2790.87c1412.66,-182.87 2295.34,-1042.93 2483.23,-2790.87l17.84 0c187.89,1747.94 1070.57,2608 2483.23,2790.87l0 -2790.87 6653.9 0 1201.82 0 7295.66 0 0 2790.87c1412.66,-182.87 2295.34,-1042.93 2483.23,-2790.87l17.84 0c187.89,1747.94 1070.57,2608 2483.23,2790.87l0 -2790.87 7272.44 0 1201.82 0 7469.86 0 0 2790.87c1412.66,-182.87 2295.34,-1042.93 2483.23,-2790.87l17.84 0c187.89,1747.94 1070.57,2608 2483.23,2790.87l0 -2790.87 7194.38 0 1201.82 0 17476.97 0 692.14 0 503.62 0 6.06 0 0 -6.75 3082.29 -3431.58 15.41 0 0 -17.16 47.02 -52.35 -47.02 -36.45 0 -111.38 27.58 0 0 -2492.15c-9.27,-0.86 -18.36,-1.85 -27.58,-2.75l0 5.5c9.22,-0.9 18.31,-1.89 27.58,-2.75l0 -2492.15 -27.58 0 0 -34176.54 27.58 0 0 -2492.15c-9.27,-0.86 -18.36,-1.85 -27.58,-2.75l0 5.5c9.22,-0.9 18.31,-1.89 27.58,-2.75l0 -2492.15 -27.58 0 0 -11464.81 -190.93 0 0 -269.3 -21527.49 0 0 -509.19 -362.32 0 0 -8660.59 -196.11 0zm-105.73 12108.04c-1047.47,154.15 -1572.43,636.5 -1691.35,1373.89l1691.35 0 320.5 0 19.45 0 0 -1410.97 0 -1410.97 -19.45 0 -320.5 0 -1691.35 0c118.92,737.39 643.88,1219.73 1691.35,1373.89l0 74.16z" />
            </g>

        </g>
    </svg>
);

export default FloorplanSVG;

